export default "__VITE_ASSET__VInS5Eek__"